export class AccountComponentsModel
{
    eligibleServiceDate : Date = null;
    taxFreeComponent :number;
    taxableComponentTaxed :number;
    preserved :number;
    restrictedNonPreserved :number
    unrestrictedNonPreserved :number;
    asAt: Date = null;
}